module.exports = __webpack_public_path__ + "static/img/timer.7cf4a355.png";